import clsx from "clsx";
import PeriodChip from "design/components/chips/PeriodChip";
import { hexToRgba, makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

export const useCardWrapperStyles = makeThemedStyles(
  "CardWrapper",
  (theme) => ({
    cardContainer: {
      display: "flex",
      flexDirection: "column",
      borderRadius: "2.28em",
      border: "1px solid #EBEFEF",
      alignItems: "center",
      position: "relative",
      width: "100%",
      minWidth: "180px",
    },
    detailContainer: {
      width: "330px",
      minHeight: "18em",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
  })
);

type ElementInEntities = {
  id: string;
  act_left: string;
  color_left: string;
  color_right: string;
  perf_left: string;
  perf_right: string;
  tar_left: string;
  tar_right: string;
};

type Props = React.PropsWithChildren<{
  period: string;
  title?: string;
  data?: ElementInEntities;
  idClass?: string;
  color?: string;
  topSpace?: boolean;
}>;
const CardWrapper = (props: Props) => {
  const { title, period, topSpace, children } = props;
  const color = props.color || "#696969";
  const styles = useCardWrapperStyles();
  return (
    <div>
      <div className={clsx(styles.cardContainer)}>
        <PeriodChip title={title} period={period} />
        <div
          style={{
            width: "100%",
            height: "100%",
            background: `linear-gradient(90deg, ${hexToRgba(
              `#${color}`,
              0.02
            )}, ${hexToRgba(`#${color}`, 0.08)}, ${hexToRgba(
              `#${color}`,
              0.02
            )})`,
          }}
          className={clsx(styles.detailContainer, props.idClass)}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default CardWrapper;
